import state from './posAppointmentState'
import mutations from './posAppointmentMutations'
import actions from './posAppointmentActions'
import getters from './posAppointmentGetters'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
